import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFormRhombus: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFormRhombus"><Path d="M19.7129 12L12.001 23.2705L4.28906 12L12.001 0.729492L19.7129 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFormRhombus;
